import {
  Column,
  Row,
  Spacer,
  Text,
} from '@components/1-atoms';
import ListItem, { ListItemData, Props as ListItemProps, ListSectionHeader } from '@components/2-molecules/ListItem';
import styled, { css } from '@emotion/native';
import React, { FC } from 'react';

import ModuleIcon from '@assets/icons/modules/documents';

import { FeedProps } from '@/interfaces/chart.interface';
import * as utils from "@lib/utils";
import { SectionList as RNSectionList, SectionListRenderItem, View } from 'react-native';
import _ from 'underscore';


type Section = { title: string; data: ReadonlyArray<FeedProps> };

// Create a typed SectionList component
const SectionList = styled(RNSectionList<FeedProps, Section>)``;

type Props = Omit<ListItemProps, 'children' | 'onPress' | 'data'> & {
  currency: string;
  data: FeedProps[];
  onPress?: (data: ListItemData) => void;
};


const TransactionList: FC<Props> = ({ currency, data, onPress, ...props }) => {
  // Create a new variable for the sectioned data to avoid reassigning the 'data' prop.
  const sectionedData = _.chain(data)
    .sortBy((transaction) => transaction.date)
    .reverse()
    .groupBy(_.property(['date']))
    .map((transactions: any, key: string) => ({
      title: `${utils.formatDate(key)}`,
      data: transactions,
    }))
    // unwraps the Underscore object to return the final result.
    .value();

  const _renderItem: SectionListRenderItem<FeedProps, Section> = ({ item }) => {
    const name = item.name;
    const right = <Text currency={currency}>{item.amount}</Text>;
    const sub = utils.sentenceCase(item?.category?.join(", ") || '');

    return (
      <View>
        <ListItem {...props} /* onPress={() => { onPress?.(item) }} */ right={right} sub={sub}>
          {name}
        </ListItem>
        <Spacer h={0.5} />
      </View>
    );
  };



  {/* Empty list message box */ }
  if (sectionedData?.length === 0) {
    return (
      <View>
        <Spacer h={3} />
        <Row style={{ justifyContent: 'center' }}>
          <ModuleIcon {...props} />
        </Row>
        <Spacer h={.9} />
        <Row>
          <Column>
            <Text align='center'{...props}>You can view your recent transactions </Text>
            <Text align='center'{...props}>here.</Text>
          </Column>
        </Row>
        <Spacer h={3} />
      </View>);
  } else {
    return (
      <View>

        {/* The `AppTemplate` provides a main ScrollView that wraps all the page content. */}
        {/* This ScrollView's job is to allow the entire page content to scroll if its content */}
        {/* is taller than the screen. */}

        {/* This SectionList is itself a scrollable view. */}

        {/* The SectionList tries to render with an infinite height, which causes the outer ScrollView */}
        {/* to think its content is infinitely tall. This breaks the layout, often causing the list to expand */}
        {/* and push everything below it off-screen, which is exactly the behavior you were seeing. */}

        {/* WARNINGS ⚠️ : The list has a infinite height when the following styles are removed.  */}
        {/*               The view contains the list inside its immediate container.*/}
        <View style={css(`width: 100%; height: auto; `)}>
          <SectionList
            scrollEnabled={true}
            sections={sectionedData as Section[]}
            keyExtractor={(item) => `${item.transaction_id}`}
            renderItem={_renderItem}
            renderSectionHeader={({ section: { title } }) => <ListSectionHeader children={title.toUpperCase()} />}
            renderSectionFooter={() => <Spacer h={1} />}
          />
        </View>
      </View>
    );
  }


};

export default TransactionList;